import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Table extends Component {
    onClickColumn(e, index) {
        if (this.props.onClickColumn) this.props.onClickColumn(index);
    }
    createHeader() {
        let ret = [];
        const columns = this.props.columns;
        let index = 0;
        for (let key in columns) {
            let i = index;
            ret.push(
                <Cell key={key} onClick={e => this.onClickColumn(e, i)}>
                    {key}
                </Cell>
            )
            index++;
        }
        return (
            <Header>
                {ret}
            </Header>
        );
    }

    onClickRow(e, index) {
        if (this.props.onClickRow) this.props.onClickRow(index);
    }
    createData() {
        let ret = [];
        const columns = this.props.columns;
        const data = this.props.data;
        let index = 0;
        for (let keyData in data) {
            let retData = [];
            for (let keyColumn in columns) {
                retData.push(
                    <Cell key={keyColumn}>
                        {data[keyData][columns[keyColumn]]}
                    </Cell>
                )
            }
            let i = index;
            ret.push(
                <Data key={keyData} Disable={data[keyData]["disable"]} onClick={e => this.onClickRow(e, i)}>
                    {retData}
                </Data>
            )
            index++;
        }
        return ret;
    }

    onClickControl(e, onClick, index) {
        if(onClick) {
            onClick(index);
        }
    }

    createControl() {
        const controls = this.props.controls;
        let ret = [];
        ret.push(
            <ControlRow key={"tr"}>
                <ControlCell key={"td"}>
                </ControlCell>
            </ControlRow>
        )
        const data = this.props.data;
        for (let keyData in data) {
            let i = keyData;
            let retData = [];
            for (let key in controls) {
                if(controls[key].control) {
                    retData.push(
                        <ControlCell key={"td" + keyData + key}  onClick={e => this.onClickControl(e, this.props.controls[key].onClick, i)}>
                            {controls[key].contents[data[keyData][controls[key].control]]}
                        </ControlCell>
                    )
                } else {
                    retData.push(
                        <ControlCell key={"td" + keyData + key}  onClick={e => this.onClickControl(e, this.props.controls[key].onClick, i)}>
                            {controls[key].contents}
                        </ControlCell>
                    )
                }
            }
            ret.push(
                <ControlRow key={"tr" + keyData}>
                    {retData}
                </ControlRow>
            )
        }

        return ret;
    }

    render() {
        return (
            <Body Height={this.props.height}>
                <Contents>
                    <TBody>
                        {this.createHeader()}
                        {this.createData()}
                    </TBody>
                </Contents>
                <Contents>
                    <TBody>
                        {this.createControl()}
                    </TBody>
                </Contents>
            </Body>
        );
    }
}

export { Table };

Table.propTypes = {
    height: PropTypes.string.isRequired,
    columns: PropTypes.object.isRequired,
    controls: PropTypes.object,
    data: PropTypes.array.isRequired,
    onClickColumn: PropTypes.func,
    onClickRow: PropTypes.func,
};

const Body = styled.div`
    height: ${props => (props.Height)};
    display: flex;

`;
const Contents = styled.table`
    height: 19px;
    border-collapse: collapse;
    color: #888;
`;
const TBody = styled.tbody`
`;
const Header = styled.tr`
    background-color: #888;
    border: 1px solid #ddd;
    td {
        color: #fff;
        cursor: pointer;
    }
`;
const Data = styled.tr`
    background-color: ${props => props.Disable ? "#cccccc" : "#fbfbfb"};
    border: 1px solid #ddd;

    :hover {
        background-color: #fffee0;
    }
`;
const Cell = styled.td`
    padding: 2px 15px;
    text-align: center;
    position: relative;
`;

const ControlRow = styled.tr`
    background-color: transparent;
`;
const ControlCell = styled.td`
    background-color: transparent;
    height: 19px;
    padding: 2px 5px;
`;